import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { PlusIcon, MagnifyingGlassIcon, PencilSquareIcon } from '@heroicons/react/24/outline';

const fetchCustomers = (params) => api.get('/customers', { params }).then(res => res.data.data);

export default function Customers() {
  const [filters, setFilters] = useState({ page: 1, limit: 20 });

  const { data, isLoading } = useQuery(['customers', filters], () => fetchCustomers(filters));

  const customers = data?.customers || [];
  const pagination = data?.pagination || {};

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Customers</h1>
          <p className="mt-1 text-sm text-slate-500">Manage customer accounts</p>
        </div>
        <Link to="/customers/new" className="btn-primary">
          <PlusIcon className="h-4 w-4 mr-2" />
          Add Customer
        </Link>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="relative">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
            <input
              type="text"
              placeholder="Search by name, consumer number, email..."
              className="input-field pl-10"
              onChange={(e) => setFilters({ ...filters, search: e.target.value, page: 1 })}
            />
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Consumer #</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Status</th>
                <th>Bills</th>
                <th className="text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {isLoading ? (
                <tr><td colSpan="6" className="text-center py-8">Loading...</td></tr>
              ) : customers.length === 0 ? (
                <tr><td colSpan="6" className="text-center py-8 text-slate-500">No customers found</td></tr>
              ) : (
                customers.map((customer) => (
                  <tr key={customer.id} className="hover:bg-slate-50">
                    <td className="font-mono text-xs">{customer.consumerNumber}</td>
                    <td className="font-medium">{customer.name}</td>
                    <td>{customer.email || '-'}</td>
                    <td>{customer.mobile || '-'}</td>
                    <td>
                      <span className={`badge ${customer.status === 'active' ? 'badge-green' : 'badge-gray'}`}>
                        {customer.status}
                      </span>
                    </td>
                    <td>{customer.bills?.length || 0}</td>
                    <td className="text-right">
                      <Link to={`/customers/${customer.id}/edit`} className="text-indigo-600 hover:text-indigo-900 mx-2">
                        <PencilSquareIcon className="h-5 w-5 inline" />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
